import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogOverlay,
  Center,
  Spinner,
  VStack,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { OverlayProps } from 'components/TaskOverlay';

interface SavingChangesDialogProps extends OverlayProps {}

export const SavingChangesDialog = ({
  isOpen,
  onClose,
}: SavingChangesDialogProps) => {
  const cancelRef = React.useRef(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      leastDestructiveRef={cancelRef}
    >
      <AlertDialogOverlay>
        <AlertDialogContent mx="20px" data-qa="saving-changes-dialog">
          <AlertDialogBody>
            <VStack>
              <Center>
                <Spinner />
              </Center>
              <div>{t`Saving your changes...`}</div>
            </VStack>
          </AlertDialogBody>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
